<template>
    <div class="header">
        <div class="header-wrap">
            <img src="../assets/img/logo.png" alt="" align="absmiddle" @click="getClickRouter">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        getClickRouter(){
            window.location.href="https://www.jasolar.com/"
        }
    },
};
</script>

<style lang="less" scoped>
.header{
    width:99%;
    height:80px;
    margin:0 auto;
    border-bottom: 1px solid #eee;
    .header-wrap{
        width:70%;
        height:100%;
        margin:0 auto;
        line-height: 80px;
        img{
         width: 136px;
        }
    }

}
</style>